import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TabChangeService {
  private tabChangeSource = new Subject<string>();
  tabChange$ = this.tabChangeSource.asObservable();
  
  emitTabChange(tabName: string) {
    this.tabChangeSource.next(tabName);
  }
}

